import { columnsVideos } from '@/domain/env/colums-videos';
import { DOCUMENTS_DB } from '@/domain/env/documents-db';
import { Video } from '@/domain/types/collections';
import usePaginatedDocuments from '@/domain/use-cases/get-paginated-documents';
import Button from '@/presentation/components/button';
import LoadMoreButton from '@/presentation/components/load-more-button';
import Table from '@/presentation/components/table';
import { useState } from 'react';
import { FiPlus } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';

const VideosPage = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<'all' | 'video' | 'podcast'>('all');
  const { data, error, isLoading, isLoadingMore, hasMore, loadMore } =
    usePaginatedDocuments<Video>(DOCUMENTS_DB.VIDEOS);

  if (isLoading) return <div>Loading...</div>;

  if (error) return <div>Error: {error}</div>;

  if (!data.length && !isLoading) return <div>No hay datos</div>;

  const handleRowClick = (row: Video) => {
    navigate(`/dashboard/videos/details/${row.id}`);
  };

  // Filtrar datos según la categoría seleccionada
  const filteredData =
    filter === 'all' ? data : data.filter((item) => item.category === filter);

  return (
    <div className="p-4 flex flex-col gap-4">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Videos</h1>

        <Link to="/dashboard/videos/add">
          <Button label="Agregar video" icon={<FiPlus />} onClick={() => {}} />
        </Link>
      </div>

      {/* Filtros */}
      <div className="flex gap-2 bg-white p-4 rounded-lg shadow-md">
        <Button
          label={`Todos (${data.length})`}
          onClick={() => setFilter('all')}
          variant={filter === 'all' ? 'primary' : 'ghost'}
        />
        <Button
          label={`Videos (${data.filter((item) => item.category === 'video').length})`}
          onClick={() => setFilter('video')}
          variant={filter === 'video' ? 'primary' : 'ghost'}
        />
        <Button
          label={`VideoPodcasts (${data.filter((item) => item.category === 'podcast').length})`}
          onClick={() => setFilter('podcast')}
          variant={filter === 'podcast' ? 'primary' : 'ghost'}
        />
      </div>

      <Table
        data={filteredData}
        columns={columnsVideos}
        onRowClick={handleRowClick}
      />

      <LoadMoreButton
        hasMore={hasMore}
        isLoadingMore={isLoadingMore}
        onLoadMore={loadMore}
      />
    </div>
  );
};

export default VideosPage;
